import { domReady } from "../helpers"

domReady(function () {
  let toggle_observer_fields
  $("a.toggle-api-key").click(function () {
    $(this).hide()
    $(".api-key .code").show()
  })

  const $role_select = $(".team-settings #member_state")
  const $observer_select = $(".team-settings #member_observer_mode")
  const $previous_completed_tracking_toggle = $("#team_completion_tracking")
  const $mood_tracking_toggle = $("#team_mood_tracking")

  $role_select.change(function () {
    const $res = $(this)
    if ($res.val().match(/inactive/)) {
      $(".team-settings .notification-selections").addClass("d-none hidden")
      $(".team-settings .badge-inactive").removeClass("d-none hidden")
    } else {
      $(".team-settings .notification-selections").removeClass("d-none hidden")
      $(".team-settings .badge-inactive").addClass("d-none hidden")
    }
    if ($res.val().match(/observer/)) {
      toggle_observer_fields(true)
      $(".team-settings .badge-observer").removeClass("d-none hidden")
    } else {
      toggle_observer_fields(false)
      $(".team-settings .badge-observer").addClass("d-none hidden")
    }
  })

  $observer_select.change(function () {
    const $res = $(this)
    toggle_observer_fields($res.is(":checked"))
  })

  toggle_observer_fields = function (disable) {
    let $prevRemindersState = $("#member_receive_reminders").prop("checked")
    if (disable) {
      $("#member_reminder_time").prop("readonly", true)
      $("#member_preferred_reminder_channel").prop("disabled", true)
      $("#member_receive_reminders").prop("disabled", true)
      console.log($prevRemindersState)
      $prevRemindersState = $("#member_receive_reminders").prop("checked") ? true : false
      console.log($prevRemindersState)
      $("#member_receive_reminders").prop("checked", false)
      console.log($prevRemindersState)
    } else {
      $("#member_reminder_time").prop("readonly", false)
      $("#member_receive_reminders").prop("disabled", false)
      $("#member_receive_reminders").prop("checked", $prevRemindersState)
      $("#member_preferred_reminder_channel").prop("disabled", false)
    }
  }

  $previous_completed_tracking_toggle.change(function () {
    $(".previous-completed-chart-toggle").toggleClass("d-none hidden")
  })

  $mood_tracking_toggle.change(function () {
    $(".mood-chart-toggle").toggleClass("d-none hidden")
  })
})
